module.exports = __webpack_public_path__ + "static/media/sel.dbeacb96.mp3";